import { render, staticRenderFns } from "./BotLine.vue?vue&type=template&id=7c122145&scoped=true&"
import script from "./BotLine.vue?vue&type=script&lang=js&"
export * from "./BotLine.vue?vue&type=script&lang=js&"
import style0 from "./BotLine.vue?vue&type=style&index=0&id=7c122145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c122145",
  null
  
)

export default component.exports